import { http, HttpResponse } from 'msw'

import { allSuppliers } from 'app/mocks/data/catalogue/suppliers'

import { searchParametersSuppliersApi } from 'app/utils/catalogue/suppliers'
import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

export const getAllSuppliers = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.suppliers.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get(
            searchParametersSuppliersApi.MANAGERS,
        )

        const nameFilter = searchParams.get(searchParametersSuppliersApi.NAME)

        let allSuppliersFiltered = allSuppliers

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = managerIdsFilter.split(',')

            allSuppliersFiltered = allSuppliersFiltered.filter((supplier) =>
                managerIdsSplit.includes(supplier.client.id.toString()),
            )
        }

        // Name filter
        if (nameFilter) {
            allSuppliersFiltered = allSuppliersFiltered.filter((supplier) =>
                supplier.name.toLowerCase().includes(nameFilter.toLowerCase()),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allSuppliersFiltered.length > limit
                ? offset + limit
                : allSuppliersFiltered.length

        const results = allSuppliersFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allSuppliersFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json({
            count: allSuppliersFiltered.length,
            next,
            results,
        })
    },
)
